// Anatomy art per main muscle group (cut from the uploaded muscle sheet).
const MUSCLE_IMAGES = {
  chest: 'chest', upper_chest: 'chest',
  back: 'back', lats: 'back', mid_back: 'back', traps: 'traps', upper_back: 'traps',
  lower_back: 'lower_back', spine: 'lower_back',
  shoulders: 'shoulders', rear_delts: 'traps',
  biceps: 'biceps', triceps: 'triceps', forearms: 'forearms', grip: 'forearms',
  core: 'core', abs: 'core', obliques: 'obliques', diaphragm: 'core',
  glutes: 'glutes', quads: 'quads', quadriceps: 'quads', hip_flexors: 'quads',
  hamstrings: 'hamstrings', calves: 'calves', adductors: 'adductors', full_body: 'chest',
};

// Bump when the artwork is re-cut: busts the service-worker image cache.
const MUSCLE_ART_VERSION = 2;

export const muscleImage = (muscle) =>
  `/muscle-${MUSCLE_IMAGES[(muscle || '').toLowerCase()] || 'chest'}.webp?v=${MUSCLE_ART_VERSION}`;

const Box = ({ imgSrc, label, value, testId }) => (
  <div
    className="flex items-center gap-3 pl-1.5 pr-2 py-1.5 rounded-xl bg-white/[0.05] border border-white/[0.08] min-h-[58px]"
    data-testid={testId}
  >
    <img src={imgSrc} alt="" aria-hidden="true" loading="lazy" draggable={false}
         className="w-11 h-11 object-contain shrink-0" />
    <div className="min-w-0">
      <div className="font-heading font-bold uppercase tracking-[0.1em] text-[9px] text-white/40 leading-none">{label}</div>
      <div className="mt-1 font-heading font-black uppercase leading-none text-[15px] text-accent truncate">{value}</div>
    </div>
  </div>
);

/** Muscle + Sets info boxes, sized to sit directly above the Replace / Swap buttons. */
export const MuscleSetsBoxes = ({ muscle, sets, reps, muscleTestId, setsTestId }) => (
  <div className="grid grid-cols-2 gap-2">
    <Box imgSrc={muscleImage(muscle)} label="Muscle"
         value={(muscle || 'full body').replace(/_/g, ' ')} testId={muscleTestId} />
    <Box imgSrc="/stat-sets-plates.webp" label="Sets"
         value={`${sets}\u00d7${reps}`} testId={setsTestId} />
  </div>
);
